module.exports = __webpack_public_path__ + "media/images/sakoju_image-a283fa2e.png";